import React, { Component } from "react";
import styles from "../../assets/css/modules/download/file-download-list.css";
import Content from "../../content/Content";
import Store from "../../content/Store";
import ToggleDrawer from "../shared/containers/ToggleDrawer";
import { handleKeyPress } from "../../helpers/KeyPressHelper";
import { getContentByVariationType } from "../../content/ContentDoneSimply";
import { connect } from "react-redux";
import { PopupBlockerWarning } from "../../features/popups/PopupBlockerWarning";
import FileDownload from "./FileDownload";
import FileDownloadRetryLink from "./FileDownloadRetryLink";
import { fileDownloadListVariationTypesAvailable } from "../../content/download/FileDownloadListContent";

export const mapStateToFileDownloadList = ({
  popupBlockerReducer = {},
  policyReducer = {}
}) => {
  const isFormat2 =
    policyReducer.selectedPolicy && policyReducer.selectedPolicy.IsFormat2;
  return {
    arePopupsBlocked: popupBlockerReducer.arePopupsBlocked,
    contentVariationType: isFormat2
      ? fileDownloadListVariationTypesAvailable.Format2
      : fileDownloadListVariationTypesAvailable.Any
  };
};

export class FileDownloadList extends Component {
  constructor(props) {
    super(props);
    this.state = { fileListToolTipVisibility: [], documents: [] };
  }

  componentDidMount() {
    if (Array.isArray(this.props.files)) {
      this.setState({
        documents: [...this.props.files]
      });
    }
  }

  componentWillReceiveProps() {
    this.setState({ fileListToolTipVisibility: [] });
  }

  toggleTooltip = (event) => {
    let index = parseInt(event.target.getAttribute("value"), 10);
    let visibilityArray = this.state.fileListToolTipVisibility;
    visibilityArray[index] = !visibilityArray[index];

    this.setState({
      fileListToolTipVisibility: visibilityArray
    });
  };

  toggleTooltipOnKeyPress = (e) => {
    handleKeyPress(e, () => {
      this.toggleTooltip(e);
    });
  };

  setDocumentUrl = (indexOfDocument, url, urlData) => {
    const documents = this.state.documents;
    documents[indexOfDocument].url = url;
    documents[indexOfDocument].urlData = urlData;
    this.setState({
      documents
    });
  };

  render() {
    const { contentVariationType, arePopupsBlocked } = this.props;

    const fileDownloadHeaders = getContentByVariationType(
      contentVariationType,
      Store.FileDownloadHeaders
    );

    return (
      <div className={styles.filesContainer}>
        {arePopupsBlocked ? <PopupBlockerWarning /> : null}
        <div className={"row " + styles.fileHeader}>
          <div data-file-name-header className="col-4">
            {fileDownloadHeaders.LabelFileName}
          </div>
          <div className="col-4" />
          <div
            data-file-link-header
            className={"col-4 " + styles.downloadLinkHeader}
          >
            {this.props.useDirectLinkDownload
              ? fileDownloadHeaders.LabelView
              : fileDownloadHeaders.LabelDownload}
          </div>
        </div>
        <hr className={styles.horizontalLine} />
        <div className={styles.files}>
          {this.props.files &&
            this.props.files.map((file, index) => {
              const fileName = getContentByVariationType(
                contentVariationType,
                file.FileName
              );

              return (
                <React.Fragment key={index}>
                  <div id={"fileBlock_" + index} className="row">
                    <div className={"col-sm-7 col-xs-6 " + styles.fileName}>
                      <span id={"fileBlockOpenInNewTab_" + index}>
                        {this.props.useDirectLinkDownload ? (
                          <a
                            href={file.ExternalLinkTo}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-filename={fileName}
                          >
                            <i className="icon-document" />
                            {fileName}
                          </a>
                        ) : (
                          <FileDownload
                            url={file.ExternalLinkTo}
                            fileName={fileName}
                            openInNewTab
                            setRetryFileUrl={(url, urlData) =>
                              this.setDocumentUrl(index, url, urlData)
                            }
                          >
                            <i className="icon-document"></i>
                            {fileName}
                          </FileDownload>
                        )}
                      </span>
                    </div>
                    <div
                      className={"col-sm-1 col-xs-6 " + styles.infoBoxWrapper}
                    >
                      <span className={styles.infoBoxIcon}>
                        <i
                          value={index}
                          className="icon-info-blue"
                          tabIndex="0"
                          onClick={this.toggleTooltip}
                          onKeyPress={this.toggleTooltipOnKeyPress}
                          title="Click for more information"
                        />
                      </span>
                    </div>
                    <div
                      className={"col-sm-4 col-xs-12 " + styles.downloadLink}
                    >
                      {this.props.useDirectLinkDownload ? (
                        <span
                          className={styles.downloadIcon}
                          id={"fileBlockDownload_" + index}
                        >
                          <a
                            href={file.ExternalLinkTo}
                            rel="noopener noreferrer"
                            target="_blank"
                            title="View and Download"
                            data-filename={fileName}
                          >
                            <i className="icon-download" />
                            <span className={styles.downloadLinkText}>
                              VIEW AND DOWNLOAD
                            </span>
                          </a>
                        </span>
                      ) : (
                        <span
                          className={styles.downloadIcon}
                          id={"fileBlockDownload_" + index}
                        >
                          <FileDownload
                            url={file.ExternalLinkTo}
                            fileName={fileName}
                            title="Download"
                            setRetryFileUrl={(url, urlData) =>
                              this.setDocumentUrl(index, url, urlData)
                            }
                          >
                            <i className="icon-download"></i>
                            <span className={styles.downloadLinkText}>
                              DOWNLOAD
                            </span>
                          </FileDownload>
                        </span>
                      )}
                    </div>
                    <div className={`col-12 ${styles.retryLinkMessage}`}>
                      {this.state.documents[index] &&
                      this.state.documents[index].url &&
                      this.state.documents[index].urlData ? (
                        <FileDownloadRetryLink
                          url={this.state.documents[index].url}
                          urlData={this.state.documents[index].urlData}
                          fileName={getContentByVariationType(
                            contentVariationType,
                            fileName
                          )}
                        />
                      ) : null}
                    </div>
                    <div className={"col-12 " + styles.tooltipRow}>
                      <ToggleDrawer
                        isOpen={this.state.fileListToolTipVisibility[index]}
                        bottom
                        gradientClass="primary"
                      >
                        <div className={"input-tooltip " + styles.infoBox}>
                          <Content name={file.Tooltip} />
                        </div>
                      </ToggleDrawer>
                    </div>
                  </div>
                  {index < this.props.files.length - 1 ? (
                    <hr className={styles.horizontalLine} />
                  ) : null}
                </React.Fragment>
              );
            })}
        </div>
        <hr className={styles.horizontalLine} />
      </div>
    );
  }
}

export default connect(mapStateToFileDownloadList)(FileDownloadList);
